/**
 * ═══ LE `t()` VU D'UN MODULE PUR ═══
 *
 * Un module sans hook (`funnel/conferences.ts`, `funnel/companyIndex.ts`) ne connaît pas
 * la langue lue : l'écran qui l'appelle lui passe son `t`. Appelé sans (ses tests), il
 * parle français, trous remplis, donc exactement comme avant d'être traduisible.
 *
 * ⚠️ LE NOM `say` N'EST PAS UN HASARD : `i18n/couverture.test.ts` reconnaît
 * `say("CLÉ", "repli")` comme `t(…)`, et fait donc rougir une clé appelée ici sans être
 * posée dans `mots.json`.
 */
export type Say = (
  key: string,
  raw: string,
  values?: ReadonlyArray<string | number>,
) => string;

/**
 * Les trous numérotés de la V1 (`$1`, `$2`), remplis dans l'ordre. Une phrase découpée
 * en morceaux à recoller figerait l'ordre des mots français.
 */
export function fill(
  sentence: string,
  values?: ReadonlyArray<string | number>,
): string {
  return (values ?? []).reduce<string>(
    (said, value, i) => said.split(`$${i + 1}`).join(String(value)),
    sentence,
  );
}

/** Le repli seul : ce que dit un module pur quand aucun écran ne lui a passé `t`. */
export const french: Say = (_key, raw, values) => fill(raw, values);
